import ltoast from './toast.vue'
import Vue from 'vue'
let instance
let timer

const ToastConstructor = Vue.extend(ltoast)


export default function (message) {
  if (instance && instance.$el) {
    instance.$el.remove()
    instance.isShow = false
    instance.$destroy()
    clearTimeout(timer)
    timer = null
  }

  instance = new ToastConstructor({
    el: document.createElement('div'),
  })

  instance.msg = message
  document.body.appendChild(instance.$el)

  Vue.nextTick(() => {
    instance.isShow = true
    timer = setTimeout(() => {
      if (instance.$el) {
        instance.$el.remove()
        instance.isShow = false
        instance.$destroy()
      }
      clearTimeout(timer)
    }, 3000)
  })

  return instance
}